import React from 'react';
import logobizco from '../../assets/logobizco.svg';
const BizCompanyPro = () => {
  return (
    <>
    <div>
            <h1 className='text-2xl ml-3  text-[#272C34] font-bold'>Company profile</h1>
            <div className='my-4 md:w-[70%] '>
              <div className='mybookings-img'>
                 <div className='account-form mx-3'>
                 <div className=' w-full '>

<form >  
<div class="mb-6">
<label for="email" class="block mb-2 text-xs font-normal text-[#131436]  ">Your name</label>
<input type="text" id="email" class="shadow-sm h-[50px]   bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-2xl   focus:border-blue-500 block w-full p-2.5 " placeholder="John Doe" required/>
</div>
<div class="mb-6">
<label for="email" class="block mb-2 text-xs font-normal text-[#131436]">Company name</label>
<input type="text" id="email" class="shadow-sm h-[50px]   bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-2xl   focus:border-blue-500 block w-full p-2.5 " placeholder="Lorem ipsum" required/>
</div>
<div class="mb-6">
<label for="email" class="block mb-2 text-xs font-normal text-[#131436]">Company email address</label>
<input type="text" id="email" class="shadow-sm h-[50px]   bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-2xl   focus:border-blue-500 block w-full p-2.5 " placeholder="companyemail@domian.com" required/>
</div>
<div class="mb-6">
<label for="password" class="block mb-2 text-xs font-normal text-[#131436]">Company website</label>
<input type="text" id="password" class="shadow-sm h-[50px]   bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-2xl focus:  focus:border-blue-500 block w-full p-2.5  " placeholder='https://www.padlecompany.com/' required/>
</div>  
<div class="mb-6">
<label for="password" class="block mb-2 text-xs font-normal text-[#131436]">Representative contact number</label>
<input type="text" id="password" class="shadow-sm h-[50px]   bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-2xl focus:  focus:border-blue-500 block w-full p-2.5  " placeholder='(000) 242-00000' required/>
</div>
<div class="mb-6">  
<label   class="block  mb-2 text-xs font-medium text-gray-700 text-[#131436]  ">Upload company logo </label>
<div class="block flex  rounded-xl   h-[100px] w-[124px]  mb-2 text-xs font-medium text-gray-700 text-[#131436]  "> 
<input type="file" id="bizimg" class="shadow-sm px-5 hidden h-[50px] bg-[#FBFEFF] border border-gray-300 text-gray-900 text-xs rounded-2xl   h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />
<img src={logobizco} className=' h-auto w-full'/> 
<label htmlFor="bizimg" className='text-[12px] bg-white mt-[59px] -ml-[42px] h-7 w-7 rounded-full text-[#6A7D95] text-center py-2' ><i class="fa-solid fa-pencil text-blue-500 cursor-pointer  "  ></i></label>
 </div>
</div>
<div class="mb-6">
<label htmlFor="password" class="block mb-2 text-xs font-medium text-gray-700 text-[#131436]  ">About company</label>
  <textarea id="w3review" className='shadow-sm px-5  rounded-2xl bg-[#FBFEFF] border border-gray-300 text-gray-900 text-xs      w-full p-2.5 focus:bg-white  ' name="w3review" rows="6" cols="50">

 </textarea>
</div>
<div class="mb-3"> 
<button type="submit" class="text-white float-right md:my-6 my-3 bg-[#409BF5] hover:bg-blue-800    font-medium rounded-xl text-sm px-16 h-[50px] text-center  ">Save</button>
</div>

 

</form>
</div>
                 </div>               
              </div>
 
            </div>
            </div>
     </>
  )
}

export default BizCompanyPro